export default __webpack_public_path__ + "static/lozenge-dropdown-do-2-dark-7d5be0b888d4d3f6cffb891cec9a162f.png";